import Good_Minimal from './Good_Minimal'

export default {
    Good_Minimal,
}
